export default __webpack_public_path__ + "static/media/truvu-logo.0fabae83.svg";